import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';

const styles = () => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
});

function OrphanedEmails({ classes, ...rest }) {
  return (
    <div className={classNames(classes.root)} {...rest} />
  );
}

export default withStyles(styles)(OrphanedEmails);
